import $ from 'jquery';
import externalLinkCall from "./externalLinkCall";
const externalLink = () => {
    if (document.querySelector('.ume-external-link')) {
        document.addEventListener('click', ev => {

            if (ev.target.closest('.ume-external-link')) {
                ev.preventDefault();
                let linkTarget = ev.target.href;

                if (!linkTarget) {
                    const link = ev.target.closest('a');
                    linkTarget = link.href;

                }
                externalLinkCall(linkTarget);


            } else {

                return;
            }

        })
    }
}
export default externalLink;